import React, { useState, useEffect } from 'react'
import { 
  ArrowLeft,
  Edit
} from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import { useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

const SACMasterView = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [sacData, setSacData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (location.state?.sacData) {
      const { sacData } = location.state
      setSacData(sacData)
      setLoading(false)
    } else {
      toast.error('No SAC data provided for viewing')
      navigate('/sales/sac-master')
    }
  }, [location.state, navigate])

  const handleEdit = () => {
    navigate('/sales/sac-master/edit', { state: { sacData } })
  }

  const handleBack = () => {
    navigate('/sales/sac-master')
  }

  const breadcrumbItems = [
    { label: 'Sales', path: '/sales', onClick: () => navigate('/sales') },
    { label: 'Masters', path: '/sales?tab=masters', onClick: () => navigate('/sales?tab=masters') },
    { label: 'SAC Master', path: '/sales/sac-master', onClick: () => navigate('/sales/sac-master') },
    { label: 'View', path: `/sales/sac-master/view/${sacData?.id}`, isCurrent: true }
  ]

  if (loading) {
    return (
      <div className="sales-dashboard">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading SAC Master data...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="sales-dashboard">
      {/* Breadcrumb Navigation */}
      <div className="breadcrumb-section">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      {/* Page Header */}
      <div className="page-header">
        <div className="page-title">
          <h1>SAC Master</h1>
          <p>Manage Services Accounting Code master data</p>
        </div>
      </div>

      {/* Form Section */}
      <div className="form-container">
        <div className="sac-form-header">
          <h2>SAC Master</h2>
        </div>
          
        <div className="form-content">
          {/* Row 1: SAC Code, Description, GST Rate */}
          <div className="grid-row-3">
            <div className="form-group">
              <label className="form-label">
                SAC Code
              </label>
              <div className="form-input-readonly">
                {sacData?.sacCode || 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                Description of Service
              </label>
              <div className="form-input-readonly">
                {sacData?.description || 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                GST Rate %
              </label>
              <div className="form-input-readonly">
                {sacData?.gstRate ? `${sacData.gstRate.toFixed(2)}%` : 'N/A'}
              </div>
            </div>
          </div>

          {/* Row 2: IGST Rate, CGST Rate, SGST Rate */}
          <div className="grid-row-3">
            <div className="form-group">
              <label className="form-label">
                IGST Rate %
              </label>
              <div className="form-input-readonly">
                {sacData?.igstRate ? `${sacData.igstRate.toFixed(2)}%` : 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                CGST Rate %
              </label>
              <div className="form-input-readonly">
                {sacData?.cgstRate ? `${sacData.cgstRate.toFixed(2)}%` : 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                SGST Rate %
              </label>
              <div className="form-input-readonly">
                {sacData?.sgstRate ? `${sacData.sgstRate.toFixed(2)}%` : 'N/A'}
              </div>
            </div>
          </div>

          {/* Row 3: UTGST Rate, Revision No, Revision Date */}
          <div className="grid-row-3">
            <div className="form-group">
              <label className="form-label">
                UTGST Rate %
              </label>
              <div className="form-input-readonly">
                {sacData?.utgstRate ? `${sacData.utgstRate.toFixed(2)}%` : 'N/A'}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                Current Version
              </label>
              <div className="form-input-readonly">
                {`Rev ${sacData?.currentRevision || 1}`}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                Revision Date
              </label>
              <div className="form-input-readonly">
                {sacData?.revisionDate ? new Date(sacData.revisionDate).toLocaleDateString() : 'N/A'}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="form-actions">
            <button
              type="button"
              onClick={handleBack}
              className="btn-secondary"
            >
              <ArrowLeft size={16} />
              Back
            </button>
            <button
              type="button"
              onClick={handleEdit}
              className="btn-primary"
            >
              <Edit size={16} />
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SACMasterView
